module.exports = __webpack_public_path__ + "university-mohawk.png?ceb682e5142492ea7860128cc7a997da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/university-mohawk.png
// module id = 149
// module chunks = 0